import { IntlShape } from 'react-intl';

export const getErrorMessageFor = (isValid: boolean, id: string, intl: IntlShape): string => {
  if (isValid) {
    return '';
  }

  // Is invalid
  return intl.formatMessage({ id });
};
